import { FC } from "react";
import { BUTTON_LABELS } from "@miplatform/constants";
import { IUserListItemResponse } from "@miplatform/types";
import { mdiPencilOutline } from "@mdi/js";
import { ConfigProfileCard } from "../../components";

export const ConfigUserProfileListCard: FC<IConfigProfileListCardProps> = ({
  item: user,
  navigateToUserDetails = () => {},
  resendInvitation = () => {},
  hideActions = false,
}) => {
  const { isDisabled, modifiedOn, firstName, lastName, status, id, createdOn } =
    user;
  const fullName = `${firstName} ${lastName}`;

  const showResendButton = !isDisabled && status === "Pending";

  const handleOnClick = () => {
    navigateToUserDetails(id);
  };

  const actionButtons = showResendButton
    ? [
        {
          name: "Resend Invite",
          onClick: () => {
            resendInvitation(user);
          },
        },
      ]
    : [];

  const editAction = {
    label: BUTTON_LABELS.EDIT,
    action: handleOnClick,
    icon: mdiPencilOutline,
  };

  return (
    <ConfigProfileCard
      name={fullName}
      isActive={!isDisabled}
      modifiedOn={modifiedOn}
      actionButtons={hideActions ? [] : actionButtons}
      menuActions={hideActions ? [] : [editAction]}
      createdOn={createdOn}
      onClick={handleOnClick}
    />
  );
};

interface IConfigProfileListCardProps {
  item: IUserListItemResponse;
  navigateToUserDetails: (userId: string) => void;
  resendInvitation: (user: IUserListItemResponse) => void;
  hideActions?: boolean;
}
